import * as React from 'react';
import moment from 'moment';

import { ICalendarState, IMonth, } from '../classes/calendar';
import { connect } from 'react-redux';

import { ICalendarAppState } from '../redux-state';
import { CalendarDeviceMode, CalendarViewMode } from '../redux-state/interfaces/calendar-settings';
import CalendarContainerView from './calendar-container.view';

interface ICalendarContainerExternalProps {

}

interface StateToProps {
    calendarViewMode: CalendarViewMode;
    calendarDeviceMode: CalendarDeviceMode;
    isLoading: boolean;
}

export type CalendarContainerProps = ICalendarContainerExternalProps & StateToProps;

export class CalendarContainerBase extends React.Component<CalendarContainerProps, any> {

    componentDidUpdate(prevProps: CalendarContainerProps) {
        const superParent = document.documentElement;

        if (this.props.isLoading) {
            // attribute removal happens in the views of the components that trigger loading states.
            // removal should happen after all other callback functionality.
            superParent.setAttribute("data-calendar-loading", "true");
        }
    }

    render() {
        return (
            <CalendarContainerView {...this.props} />
        )
    }
}

function mapStateToProps(state: ICalendarAppState, ownProps: ICalendarContainerExternalProps): StateToProps {
    return {
        calendarViewMode: state.calendarSettings.calendarViewMode,
        calendarDeviceMode: state.calendarSettings.calendarDeviceMode,
        isLoading: state.calendar.updating
    }
}

export default connect<StateToProps>(mapStateToProps)(CalendarContainerBase);